var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.685 365.402C360.126 320.157 326.052 286.138 300.638 282.732C281.311 280.142 267.855 284.71 258.745 291.972C247.201 285.168 218.638 276.7 196.742 297.255C182.496 310.629 169.93 343.171 196.742 370.43C203.164 376.959 214.281 385.176 228.581 381.601V475.029C228.581 478.343 231.267 481.029 234.581 481.029H294.638C297.952 481.029 300.638 478.343 300.638 475.029V387.601C300.638 384.288 303.36 381.626 306.566 380.79C316.38 378.228 325.967 370.205 329.685 365.402Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.463 252.222C213.774 278.921 236.493 235.894 238.961 212.908C239.092 211.69 240.264 210.821 241.47 211.039C296.263 220.962 308.107 177.881 307.077 164.498C302.444 104.338 237.6 103.901 216.798 127.578C215.994 128.494 214.575 128.596 213.713 127.734L136.235 50.2564C135.519 49.5398 134.379 49.4724 133.583 50.0995L75.7686 95.6451C74.8275 96.3864 74.7449 97.7832 75.5921 98.6303L161.132 184.17C161.878 184.916 161.905 186.122 161.23 186.933C140.652 211.636 148.494 238.434 168.463 252.222Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97.3865L161.132 184.518C161.878 185.265 161.905 186.47 161.23 187.281C140.652 211.984 148.494 238.783 168.463 252.57C213.774 279.27 236.493 236.242 238.961 213.256C239.092 212.038 240.264 211.169 241.47 211.387C296.263 221.31 308.107 178.23 307.077 164.846C302.444 104.686 237.6 104.249 216.798 127.927C215.994 128.842 214.575 128.944 213.713 128.082L134.979 49.3482",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.02 189.063C264.251 190.463 283.492 181.592 282.188 164.034",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.4 238.359C203.2 239.364 217.694 224.789 214.798 212.879",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.505 314.373C278.476 307.196 298.753 301.05 309.438 315.042",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.884 323.228C242.709 314.458 247.319 301.275 258.641 292.25M300.535 481.307V387.879C300.535 384.566 303.257 381.904 306.463 381.067C316.276 378.506 325.864 370.482 329.582 365.68C360.022 320.435 325.949 286.416 300.535 283.01C281.208 280.419 267.752 284.988 258.641 292.25M258.641 292.25C247.097 285.446 218.535 276.977 196.639 297.533C182.393 310.906 169.826 343.449 196.639 370.708C203.061 377.237 214.178 385.454 228.478 381.879M228.478 381.879V481.307M228.478 381.879C235.708 379.784 240.36 376.178 244.575 373.327",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M281.471 245.514C279.057 246.374 276.785 247.086 274.739 247.646C276.913 246.708 279.166 246.005 281.471 245.514C299.926 238.935 326.66 223.645 323.894 200.725C332.087 209.103 347.913 228.095 338.976 269.43C329.881 255.282 303.325 240.86 281.471 245.514Z",
    fill: "#F9F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M274.739 247.646C292.427 242.805 327.022 226.643 323.894 200.725C332.087 209.103 347.913 228.095 338.976 269.43C328.921 253.79 297.529 237.815 274.739 247.646Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M455.39 226.491L401.485 226.491",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.355 313.834L377.871 277.35",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M414.354 137.604L377.87 174.089",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/정형외과_슬개골 탈구.bbc4f6cdf7641264e177ad4672a3dc06.svg";
export { ForwardRef as ReactComponent };